import ResponsiveSSR from '@pretto/bricks/components/utility/ResponsiveSSR'

import { SimulatorType } from '@pretto/website/src/templates/blocs/components/simulatorRow/SimulatorRow.types'

import { FC } from 'react'

import { APP_HREF, DESCRIPTION } from '../../config'
import { Ticks } from '../Ticks'

import * as S from './styles'

type BlocInfoProps = {
  onClickButton: () => void
  projectKind: SimulatorType
  ticks: string[]
}

const BUTTON_HREF = {
  capacity: APP_HREF,
  purchase: APP_HREF,
  renegotiation: `${APP_HREF}project/renegotiation/introduction`,
}

export const BlocInfo: FC<BlocInfoProps> = ({ onClickButton, projectKind, ticks, ...props }) => (
  <S.Card {...props}>
    {DESCRIPTION}

    <S.Button href={BUTTON_HREF[projectKind]} onClick={onClickButton}>
      Simulation <ResponsiveSSR max="mobileM">avancée</ResponsiveSSR>
      <ResponsiveSSR min="mobileM">personnalisée</ResponsiveSSR>
    </S.Button>

    <Ticks ticks={ticks} />

    <S.DescriptionIllustrationContainer>
      <S.DescriptionIllustration $projectKind={projectKind} />
    </S.DescriptionIllustrationContainer>
  </S.Card>
)
